module.exports = __webpack_public_path__ + "img/sticker.a4672d1c.png";